import { Routes } from '@angular/router';
import { CareerContainerComponent } from "./career-container/career-container.component";
import { ApplyPositionComponent } from './apply-position/apply-position.component';
import { FreshersDriveComponent } from './freshers-drive/freshers-drive.component';
import { OpenPositionsComponent } from './open-positions/open-positions.component';
import { CareerAtKalpitaComponent } from './career-at-kalpita/career-at-kalpita.component';

export const Careers_Routes: Routes = [
    {path: '', component: CareerContainerComponent,children: [
        {
        path: 'kalpita-open-positions',
        component: OpenPositionsComponent,
        data: {
          title: 'Explore the Latest Job Openings  | Kalpita Job Board',
          description:
            'View our recent job openings for exciting career opportunities at Kalpita. Take the next step in your professional journey to join our talented team.',
          keywords: 'job openings ',
        },
      },

      {
        path: 'applyposition/:id',
        component: ApplyPositionComponent,
        data: {
          title: 'Apply Now for your Dream Job at Kalpita in Bangalore and USA',
          description:'Join Kalpita Technologies, a leader in AI and software development. We’re hiring IT and AI experts in Bangalore, India, and the USA. Apply now and grow with us!',
          keywords: 'AI jobs, software careers, IT hiring, cloud jobs, apply now',
        },
      },
      {path:'career-at-kalpita',component:CareerAtKalpitaComponent}
    ]},
]